const Request = require('./BaseRequest')
const CoreGraph = require('../graph/CoreGraph')

module.exports = class CoreRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new CoreGraph(this.apiDomain)
    }

    swrCountry(code)
    {
        let args = {code: code}
        let { type, query} = this.graph.countryQuery([
            'id', 'name', 'alpha2', 'alpha3', 'phone_code'
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrCountries(optional={})
    {
        let args = {...optional}
        let { type, query} = this.graph.countriesQuery([
            'id', 'name', 'alpha2', 'alpha3', 'phone_code'
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    async countries(optional={})
    {
        let args = {...optional}
        let { type, query} = this.graph.countriesQuery([
            'id', 'name', 'alpha2', 'alpha3', 'phone_code'
        ], args)
        
        let data = await this.graph.request(query, args, type)
        return data
    }

    async states(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.statesQuery([
            'id', 'name', 'code'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrState(code)
    {
        let args = {code: code}
        let { type, query} = this.graph.stateQuery([
            'id', 'name', 'code'
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrStates(optional={})
    {
        let args = {...optional}
        let { type, query} = this.graph.statesQuery([
            'id', 'name', 'code', {country: ['id', 'name']}
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }
}